import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import UsersTable from "./UsersTable"
import RegisterForm from '../user/RegisterForm';
import Loader from '../theme/Loader'
import LoaderPanel from '../theme/LoaderPanel'



function a11yProps(index) {
  return {
    id: `horizontal-tab-${index}`,
    'aria-controls': `horizontal-tabpanel-${index}`,

  };
}



const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`horizontal-tabpanel-${index}`}
      aria-labelledby={`horizontal-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{
          pl: 5, pr: 5, pt: 5,

        }}>
          {children}
        </Box>
      )}
    </div>
  );
}
export default function AdminTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (

    <Box
      sx={{
        bgcolor: 'background.paper',

      }}

    >

      <AppBar position="static"
        color={'white'}
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',

        }}>
        <Tabs
          orientation="horizontal"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="admin panel tabs"
          sx={{
            borderColor: 'divider',

          }}
        >
          <Tab label="Users List" {...a11yProps(0)} />
          <Tab label="Add User" {...a11yProps(1)} />
          <Tab label="Stats Panel" {...a11yProps(2)} />
          <Tab label="Loader Panel" {...a11yProps(3)} />

        </Tabs>
      </AppBar>
      <Box
        sx={{
          bgcolor: 'background.paper',
          height: "90vh",
          overflow: "auto"

        }}
      >
        <CustomTabPanel value={value} index={0}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              pl: '2rem',
              pr: '2rem',

            }}
          >
            <UsersTable />
          </Box>

        </CustomTabPanel>


        <CustomTabPanel value={value} index={1}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              pb: 10,

            }}
          >
            <RegisterForm
              admin={true}
            />


          </Box>

        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',


            }}
          >
            <Loader />

          </Box>

        </CustomTabPanel>


        <CustomTabPanel value={value} index={3}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',

            }}
          >
            <LoaderPanel />

          </Box>

        </CustomTabPanel>
      </Box>
    </Box>

  );
}
